module.exports = __webpack_public_path__ + "img/coupon_mb_tab_02.8393168b.png";